export default __webpack_public_path__ + "static/media/ltr-sb-img.80913f66.webp";